export const abbr = (string: string): string => string
    .toUpperCase()
    .split(' ')
    .map(part => part.substring(0, 1))
    .join('');
